import {InjectionToken} from '@angular/core'
import {AuthGuardEmbeddedService} from '@service/auth/auth-guard.embedded.service'
import {AuthGuardService} from '@service/auth/auth-guard.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `AuthGuardService`.
 *
 * @description
 * En modo embebido se usa `AuthGuardEmbeddedService`, que confía en la
 * sesión proporcionada por la app host. En modo standalone se usa
 * `AuthGuardService`, que evalúa la sesión almacenada localmente para
 * proteger las rutas privadas.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia concreta del guard activo.
 */
export function providerAuthGuardServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new AuthGuardEmbeddedService() : new AuthGuardService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `AuthGuardService`.
 *
 * @description
 * Se registra en `SERVICE_PROVIDERS` junto con
 * {@link providerAuthGuardServiceFactory}; los guards de ruta inyectan el
 * servicio vía el alias declarado en `providers.ts`.
 */
export const AuthGuardServiceToken = new InjectionToken<AuthGuardService>('AuthGuardService')
